export function addCustomerStatus()
{
    return({
        type:"ADD_CUSTOMER_STATUS"
    })
}